// Feature flags configuration
const featureFlags = {
  useFirestore: true, // Force enable Firestore
  isDevEnvironment: process.env.NODE_ENV === 'development'
};

export const isFirestoreEnabled = () => true; // Always return true
export const isDevEnvironment = () => featureFlags.isDevEnvironment;

export default featureFlags; 